var map = {
	"./aravindh.webp": 25482,
	"./chandrasekar.webp": 60760,
	"./gomathy.webp": 80984,
	"./gunasekar.webp": 61342,
	"./karthik.webp": 29381,
	"./karthikeyan.webp": 14772,
	"./logesh.webp": 58795,
	"./logeswaran.webp": 55294,
	"./magudeswaran.webp": 28650,
	"./maheswari.webp": 17600,
	"./msureshslg.webp": 20034,
	"./mythili.webp": 73241,
	"./prabhu.webp": 59187,
	"./priyadharshini.webp": 19150,
	"./ranjithkumar.webp": 83661,
	"./ravisankar.webp": 74833,
	"./sabarimuthu.webp": 74434,
	"./sarathkumar.webp": 42372,
	"./senthilnathan.webp": 32030,
	"./sivachitra.webp": 59031,
	"./srinivasan.webp": 12479,
	"./surendar.webp": 10321,
	"./suresh.webp": 77719,
	"./tamilarasu.webp": 13554,
	"./thangaraj.webp": 11999,
	"./usha.webp": 42902,
	"./venkatachalam.webp": 53517,
	"./vpavithra.webp": 6898
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 77141;